<div class="public-form">
  <div class="container">
    <div class="row justify-content-center pt-5">
      <div class="col-12">
        <div class="logo mb-3">
          <img
            class="img-fluid"
            src="assets/logo_horiz_dark.png"
            alt="GroweLab" />
          <div class="text-center">ProForms</div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center rounded pb-5 pt-2 px-3 px-md-0">
      <div class="col-lg-8 bg-white p-3 p-md-5">
        <ng-container *ngIf="formId">
          <app-proforms-form
            [formId]="formId"
            [viewState]="viewStates.EDIT"
            [context]="contextType"
            [contextId]="formId"
            (formSubmitted)="onFormSubmit($event)"
            (showGradedQuiz)="openGradedQuizModal($event)" />
        </ng-container>
      </div>
    </div>
  </div>
</div>

<app-modal
  #gradedQuizModal
  (isDismissing)="gradedQuizModal.close()"
  [modalConfig]="{
  headerClass: ['modal-header', 'bg-primary', 'text-white'],
  customFooter: true,
  showFooter: false,
  titleText: 'View Graded Quiz',
  options: {
    size: 'lg',
  }
}">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="gradedQuizModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="px-5 py-4">
    <app-proforms-form
      *ngIf="gradedFormId && gradedSubmissionId"
      [formId]="gradedFormId"
      [submissionId]="gradedSubmissionId"
      [viewState]="viewStates.GRADED">
    </app-proforms-form>
  </div>
</app-modal>
